import  styles from './Doc.module.css'
import React, {useRef, useState} from "react";
import MainFormTemplate from "../../FormTemplate/MainFormTemplate/MainFormTemplate";
import WorkLine from "../../FormTemplate/WorkLine/WorkLine";
import useApiQuery from "../../ApiQuery/UseApiQuery";
import InputItem, {IRefInputItem} from "../../FormTemplate/InputItem/InputItem";
import ErrorLineItem, {ErrorLineItemRef} from "../../FormTemplate/ErrorLineItem/ErrorLineItem";
import SelectUnit, {SelectUnitDataInt} from "../../FormTemplate/SelectUnit/SelectUnit";
export default function DocBeeline()
{


    const dataChange = useRef<{
        orderId:string
        tarifId:string
        dummySign:boolean
    }>()
    const [ldrChange,rsChange,exChange] = useApiQuery("/doc/beeline/change","post",dataChange);


    const dataMnpDepartment = useRef<{
        orderId:string
        fromOperId:string
        dummySign:boolean
    }>()
    const [ldrMnpDepartment,rsMnpDepartment,exMnpDepartment] = useApiQuery("/doc/beeline/mnp/statement","post",dataMnpDepartment);

    const dataContract = useRef<{
        orderId:string
        city:string
        birthPlace:string
        tarifId:string
        gender:string
        dummySign:boolean
        address?:{
            city:string
            street:string
            home:string
            room:string
        }
    }>()
    const [ldrContract,rsContract,exContract] = useApiQuery("/doc/beeline/contract","post",dataContract);


    const refState = useRef<ErrorLineItemRef>(null)

    const [fromOperId, setFromOperId] = useState("")
    const refOper = useRef<IRefInputItem>(null)

    const [orderId, setOrderId] = useState("")
    const refOrder = useRef<IRefInputItem>(null)

    const [city, setCity] = useState("")
    const refCity = useRef<IRefInputItem>(null)

    const [adCity, setAdCity] = useState("")
    const refAdCity = useRef<IRefInputItem>(null)

    const [adStreet, setAdStreet] = useState("")
    const refAdStreet = useRef<IRefInputItem>(null)

    const [adHome, setAdHome] = useState("")
    const refAdHome = useRef<IRefInputItem>(null)

    const [adRoom, setAdRoom] = useState("")
    const refAdRoom = useRef<IRefInputItem>(null)


    const [dummySign, setDummySign] = useState(true)

    const [birthPlace , setBirthPlace]= useState("")
    const refBirthPlace = useRef<IRefInputItem>(null)

    const [tarifId , setTarifId]= useState("")
    const refTarifId = useRef<IRefInputItem>(null)

    const [genderList] = useState<SelectUnitDataInt[]>([
        {
            name: "Мужской",
            val: "M"

        },
        {
            name: "Женский",
            val: "F"

        },
    ])
    const [gender, setGender] = useState("")


    const [work, setWork] = useState(false)

    const handleMnpStatement = ()=>{
        if(!refState.current) return
        if(refOper.current && !refOper.current.validate())
        {
            refState.current.show("Оператор донор не корректен",true, 3000)
            return;
        }
        if(refOrder.current && !refOrder.current.validate())
        {
            refState.current.show("Номер заказа не коррекетн",true, 3000)
            return;
        }
        dataMnpDepartment.current={
            orderId: orderId,
            fromOperId: fromOperId,
            dummySign:dummySign
        }
        setWork(true)
        exMnpDepartment().then((e)=>{
            setWork(false)
            if(e?.success)
            {
                try {
                    e?.payload.blob().then((blob: any) => {
                        const fileURL = window.URL.createObjectURL(blob);
                        let alink = document.createElement("a");
                        alink.href = fileURL;
                        alink.download = "SamplePDF.pdf";
                        alink.click();
                    })

                } catch (e) {
                    console.log(e)
                }
                return
            }
            if(refState.current)refState.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера", true,4000)
        })

    }
    const handleContract = ()=>{
        if(!refState.current) return
        if(refOrder.current && !refOrder.current.validate())
        {
            refState.current.show("Номер заказа не корректен",true, 3000)
            return;
        }
        if(refCity.current && !refCity.current.validate())
        {
            refState.current.show("Город контракта не корректен",true, 3000)
            return;
        }
        console.log("gender", gender)
        if(gender?.length === 0)
        {
            refState.current.show("Пол не выбран",true, 3000)
            return;
        }
        if(refBirthPlace.current && !refBirthPlace.current.validate())
        {
            refState.current.show("Место рождения не корректено",true, 3000)
            return;
        }
        if(refTarifId.current && !refTarifId.current.validate())
        {
            refState.current.show("Тариф не корректен",true, 3000)
            return;
        }
        let isAddress = false
        let needCheckAddress = false
        if(refAdCity.current && refAdCity.current.validate())
        {
            isAddress = true
            needCheckAddress = true
        }
        if(refAdStreet.current && refAdStreet.current.validate())
        {
            isAddress = true
            needCheckAddress = true
        }
        if(refAdHome.current && refAdHome.current.validate())
        {
            isAddress = true
            needCheckAddress = true
        }
        if(refAdCity.current && !refAdCity.current.validate())
        {
            isAddress = false
        }
        if(refAdStreet.current && !refAdStreet.current.validate())
        {
            isAddress = false
        }
        if(refAdHome.current && !refAdHome.current.validate())
        {
            isAddress = false
        }

        console.log("x", isAddress, needCheckAddress)
        if(!isAddress && needCheckAddress)
        {
            refState.current.show("Адресс не корректен", true, 5000)
            return;
        }

        let address = isAddress ? {
            city: adCity,
            street: adStreet,
            home: adHome,
            room: adRoom?.length ? adRoom : "-"
        } : undefined



        dataContract.current={
            orderId: orderId,
            gender: gender,
            city: city,
            birthPlace: birthPlace,
            address: address,
            tarifId:tarifId,
            dummySign: dummySign,
        }
        setWork(true)
        exContract().then((e)=>{
            setWork(false)
            if(e?.success)
            {
                try {
                    e?.payload.blob().then((blob: any) => {
                        const fileURL = window.URL.createObjectURL(blob);
                        let alink = document.createElement("a");
                        alink.href = fileURL;
                        alink.download = "SamplePDF.pdf";
                        alink.click();
                    })

                } catch (e) {
                    console.log(e)
                }
                return
            }
            if(refState.current)refState.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера", true,4000)
        })

    }
    const handleChange = ()=>{
        if(!refState.current) return
        if(refOrder.current && !refOrder.current.validate())
        {
            refState.current.show("Номер заказа не коррекетн",true, 3000)
            return;
        }
        if(refTarifId.current && !refTarifId.current.validate())
        {
            refState.current.show("Тариф не корректен",true, 3000)
            return;
        }

        dataChange.current={
            orderId: orderId,
            tarifId: tarifId,
            dummySign: dummySign,
        }
        setWork(true)
        exChange().then((e)=>{
            setWork(false)
            if(e?.success)
            {
                try {
                    e?.payload.blob().then((blob: any) => {
                        const fileURL = window.URL.createObjectURL(blob);
                        let alink = document.createElement("a");
                        alink.href = fileURL;
                        alink.download = "SamplePDF.pdf";
                        alink.click();
                    })

                } catch (e) {
                    console.log(e)
                }
                return
            }
            if(refState.current)refState.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера", true,4000)
        })

    }


    return (
        <div className={styles.mainCont}>
            <MainFormTemplate title={"Документы Билайн B2B"} maxWidth={"1500px"}>
                <WorkLine load={work}></WorkLine>
                <div className={"row"}>
                    <div className={"d-flex col-md-3"}>
                        <InputItem
                            ref={refOrder}
                            title={"Заказ"}
                            val={orderId}
                            mode={"ei"}
                            placeHolder={"Номер"}
                            info={"Номер заказа"}
                            regExp={/^[0-9\w]{3,}$/ui}
                            onChange={(e)=>setOrderId(e)}
                        />

                    </div>
                    <div className={"d-flex col-md-3"}>
                        <InputItem
                            ref={refOper}
                            title={"Оператор"}
                            val={fromOperId}
                            mode={"ei"}
                            placeHolder={"Донор"}
                            info={"Имя оператора донора "}
                            regExp={/^[\w\W]{3,}$/ui}
                            onChange={(e)=>setFromOperId(e)}
                        />

                    </div>
                    <div className={"d-flex col-md-3"}>
                        <InputItem
                            ref={refCity}
                            title={"Город"}
                            val={city}
                            mode={"ei"}
                            placeHolder={"Город"}
                            info={"Город договора"}
                            regExp={/^[\w\W]{3,}$/ui}
                            onChange={(e)=>setCity(e)}
                        />

                    </div>
                    <div className={"d-flex col-md-3"}>
                        <InputItem
                            ref={refTarifId}
                            title={"Тариф"}
                            val={tarifId}
                            mode={"ei"}
                            placeHolder={"Тариф"}
                            info={"Код тарифа"}
                            regExp={/^[\w\W]{3,}$/ui}
                            onChange={(e)=>setTarifId(e)}
                        />

                    </div>



                </div>

                <div className={styles.rowCont}>
                    <div className={styles.rowTitle}>Адрес</div>
                    <div className={"row"}>
                        <div className={"d-flex col-md-3"}>
                            <InputItem
                                ref={refAdCity}
                                title={"Город"}
                                val={adCity}
                                mode={"ei"}
                                placeHolder={"Город"}
                                info={"Город прописки"}
                                regExp={/^[\w\W]{3,}$/ui}
                                onChange={(e)=>setAdCity(e)}
                            />

                        </div>
                        <div className={"d-flex col-md-3"}>
                            <InputItem
                                ref={refAdStreet}
                                title={"Улица"}
                                val={adStreet}
                                mode={"ei"}
                                placeHolder={"Улица"}
                                info={"Улица прописки"}
                                regExp={/^[\w\W]{3,}$/ui}
                                onChange={(e)=>setAdStreet(e)}
                            />

                        </div>
                        <div className={"d-flex col-md-3"}>
                            <InputItem
                                ref={refAdHome}
                                title={"Дом"}
                                val={adHome}
                                mode={"ei"}
                                placeHolder={"Дом"}
                                info={"Дом прописки"}
                                regExp={/^[\w\W]{1,}$/ui}
                                onChange={(e)=>setAdHome(e)}
                            />

                        </div>
                        <div className={"d-flex col-md-3"}>
                            <InputItem
                                ref={refAdRoom}
                                title={"Квартира"}
                                val={adRoom}
                                mode={"ei"}
                                placeHolder={"Квартира"}
                                info={"Квартира прописки"}
                                regExp={/^[\w\W]{1,}$/ui}
                                onChange={(e)=>setAdRoom(e)}
                            />

                        </div>



                    </div>

                </div>
                <div className={"row"}>
                    <div className={"d-flex col-md-6"}>
                        <InputItem
                            ref={refBirthPlace}
                            title={"Место рождения"}
                            val={birthPlace}
                            mode={"ei"}
                            placeHolder={"Мето рождения"}
                            info={"Место рождения"}
                            regExp={/^[\w\W]{3,}$/ui}
                            minWidth={"100%"}
                            titleShift={-1}
                            onChange={(e)=>setBirthPlace(e)}
                        />

                    </div>
                    <div className={"d-flex col-md-2"}>
                        <div className={styles.suCont}>
                            <SelectUnit
                                inData={genderList}
                                capt={"Пол"}
                                getVal={(e)=>setGender(e[0] ? e[0] : "")}
                            />

                        </div>
                    </div>
                    <div className={"d-flex col-md-4"}>
                        <InputItem
                            val={dummySign}
                            mode={"ei"}
                            title={"Натурал. подпись"}
                            info={"Поддеоьная подпись, зато синяя"}
                            onChange={(e)=> setDummySign(e)}
                            inputType={1}
                            minWidth={"100%"}
                        />
                    </div>



                </div>

                <div className={"row"}>
                    <ErrorLineItem ref={refState}></ErrorLineItem>
                </div>

                <div className={styles.btnCont}>
                    <button type="button" className="btn btn-secondary "
                            onClick={()=>handleMnpStatement()}
                    >Заявление [мнп]</button>
                    <button type="button" className="btn btn-secondary "
                            onClick={()=>handleContract()}
                    >Новый номер</button>
                    <button type="button" className="btn btn-secondary "
                            onClick={()=>handleChange()}
                    >Смена тарифа [bee to bee]</button>


                </div>


            </MainFormTemplate>
        </div>
    )
}